var map = {
	"./Innovation.router.js": "4566",
	"./achievements.router.js": "c224",
	"./educationService.router.js": "faba",
	"./finance.router.js": "2b3c",
	"./index.router.js": "3d9b",
	"./knowledge.router.js": "20c7",
	"./review.router.js": "5c86",
	"./sys.router.js": "e7a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3116";